import { render, staticRenderFns } from "./BaseContentPage.vue?vue&type=template&id=2dd6c49e&scoped=true"
import script from "./BaseContentPage.vue?vue&type=script&lang=js"
export * from "./BaseContentPage.vue?vue&type=script&lang=js"
import style0 from "./BaseContentPage.vue?vue&type=style&index=0&id=2dd6c49e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd6c49e",
  null
  
)

export default component.exports